module.exports = require("lodash/lang");


//////////////////
// WEBPACK FOOTER
// external "lodash/lang"
// module id = 127
// module chunks = 0 1